export const buyStepperName = {
    orderStep: "Order setup",
    ist: "Buy investments",
    review: "Review",
    confirmation: "Confirmation",
};
